export default function ManagementPage({ children }) {
  return (
    <div className="hub-page bg-surface-secondary">
      {children}
    </div>
  );
}
